import { render, staticRenderFns } from "./StartExam.vue?vue&type=template&id=1047cfd5&scoped=true&"
import script from "./StartExam.vue?vue&type=script&lang=js&"
export * from "./StartExam.vue?vue&type=script&lang=js&"
import style0 from "./StartExam.vue?vue&type=style&index=0&id=1047cfd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047cfd5",
  null
  
)

export default component.exports